import { render, staticRenderFns } from "./errorPrompt.vue?vue&type=template&id=2423ee3e&scoped=true&"
import script from "./errorPrompt.vue?vue&type=script&lang=ts&"
export * from "./errorPrompt.vue?vue&type=script&lang=ts&"
import style0 from "./errorPrompt.vue?vue&type=style&index=0&id=2423ee3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2423ee3e",
  null
  
)

component.options.__file = "errorPrompt.vue"
export default component.exports